import { BrandName } from '@seek/je-shared-data/lib/types/brand';

const brandAppAvailable = [BrandName.JORA, BrandName.JOBSTREETEXPRESS];

export const isAppAvailableForBrand = (brand: BrandName): boolean =>
  brandAppAvailable.includes(brand);
